module.exports = __webpack_public_path__ + "img/t4-4.e36643c4.svg";